import { render, staticRenderFns } from "./ResetFallback.vue?vue&type=template&id=18e43823&scoped=true&"
import script from "./ResetFallback.vue?vue&type=script&lang=js&"
export * from "./ResetFallback.vue?vue&type=script&lang=js&"
import style0 from "./ResetFallback.vue?vue&type=style&index=0&id=18e43823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e43823",
  null
  
)

export default component.exports